module.exports = __webpack_public_path__ + "static/media/instantWin.5ed97dbe.png";